import React from "react";
import {components} from "react-select";
import {get, set, forOwn, omit} from "lodash";
import Flag from "../../../../display/Flag";
import {SelectDynamicValueFunction} from "../../index";

/**
 * Select single value replacement component using Flag component
 * @description Use this as an SingeValue component replacement for the SelectInput (react-select) component. You can 
 * pass Label component props through 'singleValueProps' prop of the SelectInput component. These prop can be an 
 * instance of SelectDynamicValueFunction class if prop should depend on option data.
 *
 * @param {Object} - Singe value props sent by the react-select component to all the single values.
 * @return {JSX.Element}
 * @constructor
 */
const FlagSingleValueComponent = ({children, ...props}) => {
	const singleValueProps = get(props, 'selectProps.singleValueProps', {});

	// If any prop is an instance of SelectDynamicValueFunction class, call the inner func and pass the option data to it 
	// to get the actual value
	let flagComponentProps = {};
	forOwn(singleValueProps, (value, key) => {
		if (value instanceof SelectDynamicValueFunction) {
			try { set(flagComponentProps, key, value.func(props.data)); } 
			catch (e) { omit(flagComponentProps, [key]); }
		}
		else set(flagComponentProps, key, value);
	});
	
	return (
		<components.SingleValue {...props}>
			{flagComponentProps ? <Flag {...flagComponentProps} /> : null} {children}
		</components.SingleValue>
	)
};

export default FlagSingleValueComponent;